import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import AccountManagement from './pages/AccountManagement'
import DailyTasks from './pages/DailyTasks'
import CultivateGeneral from './pages/CultivateGeneral'
import GroupManagement from './pages/GroupManagement'
import Changelog from './pages/Changelog'
import { useAppStore } from './stores/appStore'
import { TaskRuntimeProvider } from './contexts/TaskRuntimeContext'

function App() {
  const { initializeApp } = useAppStore()

  React.useEffect(() => {
    initializeApp()
  }, [initializeApp])

  return (
    <TaskRuntimeProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<AccountManagement />} />
            <Route path="/account-management" element={<AccountManagement />} />
            <Route path="/daily-tasks" element={<DailyTasks />} />
            <Route path="/group-management" element={<GroupManagement />} />
            <Route path="/cultivate-general" element={<CultivateGeneral />} />
            <Route path="/changelog" element={<Changelog />} />
          </Routes>
        </Layout>
      </Router>
    </TaskRuntimeProvider>
  )
}

export default App
